import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faStar } from '@fortawesome/free-solid-svg-icons';
import logo from '../assets/logo2.png';
import newBg from '../assets/new-bg.jpg';
import './Hero.css';

const Hero = ({ events = [] }) => {
  const count = events.length;
  const gridClassName =
    count === 1 ? 'events-grid events-grid--single' : 'events-grid';
  const isEmpty = events.length === 0;

  return (
    <section className={`hero-section ${isEmpty ? 'hero-section--no-scroll' : ''}`}>
      <div
        className={`hero-banner ${isEmpty ? 'hero-banner--no-scroll' : ''}`}
        style={{ backgroundImage: `url(${newBg})` }}
      >
        <div className="hero-overlay"></div>
        <div className={`hero-content ${isEmpty ? 'hero-content--no-scroll' : ''}`}>
          {/* Logo */}
          <div className="hero-logo">
            <img src={logo} alt="Event Logo" className="logo-img" />
          </div>

          {/* Main Title */}
          {!isEmpty ? (
            <h1 className="hero-title">
              <FontAwesomeIcon icon={faStar} className="title-icon" /> Upcoming Events
            </h1>
          ) : null}

          {/* Venue */}
          {!isEmpty ? <p className="hero-venue">The Retro Street – Frisco</p> : null}

          {/* Events Grid */}
          {isEmpty ? (
            <div className="events-empty">
              <div className="events-empty-title">Stay tuned for events</div>
              <div className="events-empty-subtitle">New updates will be posted here soon.</div>
            </div>
          ) : (
            <div className={gridClassName}>
              {events.map((event) => (
                <div key={event.id} className="event-card">
                  <div className="event-card-content">
                    {/* Event Title */}
                    <h2 className="event-card-title">{event.title}</h2>

                    {/* Event Date */}
                    <div className="event-date-badge">
                      <span className="event-date">{event.formattedDate}</span>
                    </div>

                    {/* Book Now Button */}
                    <a href={event.bookingUrl} className="event-cta-button" target="_self">
                      Book Now
                    </a>
                  </div>
                </div>
              ))}
            </div>
          )}
        </div>
      </div>
    </section>
  );
};

export default Hero;
